export const trackTables = {
  PREPARATION_DETAILS: "preparation_details",
  BILLING_INFORMATION: "billing_information",
  ENROLLMENT_DETAILS: "enrollment_details"
};
export const VALIDATION_LABELS_SECTION = "validation_labels_section";
export const commonLabels = {
  [trackTables.ENROLLMENT_DETAILS]: {
    programName: "patientApplications.program_name",
    programSponsor: "patientApplications.program_sponsor",
    brandName: "patientApplications.medications_covered",
    drugType: "patientApplications.medication_order_type",
    relevantDrugs: "patientApplications.medications_covered",
    assistanceType: "patientApplications.assistance_type",
    tags: "patientApplications.tags",
    assignees: "patientApplications.assignees",
    diagnosisCovered: "patientApplications.diagnosis_covered",
    noOtherBrands: "patientApplications.no_other_brands",
    coveredMedicationsTooltip: "patientApplications.covered_medications_tooltip",
    noRelevantDrugs: "patientApplications.no_relevant_medications",
    freeDrug: "patientApplications.free_medication",
    replacementDrug: "patientApplications.replacement_medication",
    memberId: "patientApplications.member_id",
    applicationId: "patientApplications.application_id",
    applicationIdWaitList: "patientApplications.waitlist_application_id",
    appliedDate: "patientApplications.applied_date",
    approvedDate: "patientApplications.approved_date",
    indefinitely: "patientApplications.indefinitely",
    validThrough: "patientApplications.valid_through",
    approvedAmount: "patientApplications.max_benefit",
    lookbackPeriodStarts: "patientApplications.lookback_period_starts",
    manageTailormedPharmacy: "patientApplications.manage_orders_in_pharmacy",
    missingInformationDate: "patientApplications.missing_information_date",
    notReturnedDate: "patientApplications.not_returned_date",
    ineligibleDate: "patientApplications.ineligible_date",
    notInterestedDate: "patientApplications.not_interested_date",
    canceledDate: "patientApplications.canceled_date",
    rejectedDate: "patientApplications.denied_date",
    rejectReason: "patientApplications.denied_reason",
    missingInformationReason: "patientApplications.missing_information_reason",
    notReturnedReason: "patientApplications.not_returned_reason",
    ineligibleReason: "patientApplications.ineligible_reason",
    notInterestedReason: "patientApplications.not_interested_reason",
    canceledReason: "patientApplications.canceled_reason"
  },
  [trackTables.PREPARATION_DETAILS]: {
    sentToPatientOn: "patientApplications.sent_to_patient",
    receivedFromPatientOn: "patientApplications.received_from_patient",
    sentToPhysicianOn: "patientApplications.sent_to_physician",
    receivedFromPhysicianOn: "patientApplications.received_from_physician",
    mailTrackingOutbound: "patientApplications.mail_tracking_outbound",
    mailTrackingInbound: "patientApplications.mail_tracking_inbound",
    personNameYouSpokeTo: "patientApplications.program_contact"
  },
  [trackTables.BILLING_INFORMATION]: {
    bin: "patientApplications.bin",
    pcn: "patientApplications.pcn",
    group: "patientApplications.group",
    copayCard: "patientApplications.copay_card",
    cvv: "patientApplications.cvv",
    expiryDate: "patientApplications.expiry_date",
    zip: "patientApplications.zip_code"
  }
};
export const trackValidationLabels = {
  [VALIDATION_LABELS_SECTION]: {
    applicationId: "patientApplications.validation_message.application_id"
  }
};
